module.exports = __webpack_public_path__ + "img/background.f0e790a9.jpg";